export const site = {
  name: 'Fincrex',
  legalName: 'Fincrex s.r.o.',
  registrationId: '56 350 996',
  email: 'info@fincrex.sk',
  phone: '+421 949 261 862',
  phoneHref: '+421949261862',
  instagram: 'https://www.instagram.com/',
  address: {
    street: 'Námestie 1. mája 8062/11',
    locality: 'Bratislava – Staré Mesto',
    postalCode: '811 06',
    country: 'SK',
  },
} as const;

export const addressLines = [
  site.address.street,
  `${site.address.postalCode} ${site.address.locality}`,
] as const;

export const sectionIds = {
  top: 'top',
  about: 'about',
  capabilities: 'capabilities',
  portfolio: 'portfolio',
  directions: 'directions',
  approach: 'approach',
  fit: 'fit',
  contact: 'contact',
  privacy: 'privacy',
} as const;

export const navKeys = ['about', 'directions', 'portfolio', 'approach', 'contact'] as const;

export type NavKey = (typeof navKeys)[number];

export const projects = [
  { id: 'nota', name: 'Nota', caption: 'Flowers Boutique', cover: 'rings' },
  { id: 'gamers-lab', name: 'Gamers\nLab', caption: null, cover: 'grid' },
  { id: 'dark-pixel', name: 'Dark\npixel', caption: null, cover: 'square' },
] as const;

export type Project = (typeof projects)[number];
export type ProjectCover = Project['cover'];
